import {firestore} from "../firebase/firebase-utils";

export async function changeAtlasSaleMapped(sale) {
	try {
		await firestore.collection("atlasSales").doc(sale.id).update({mapped: !sale.mapped});
	} catch (error) {
		console.log(error);
	}
}
